import React from 'react';
const chips = ['No forms to fill', 'Refunded to your original payment method', 'Keep the bonuses'];
export function Guarantee() {
  return <section aria-labelledby="guarantee-heading" className="w-full bg-rink" data-id="element-128" data-mp="1o5q1qgnuw7zz">
      <div className="max-w-3xl mx-auto px-5 py-16 sm:py-20 text-center" data-id="element-129" data-mp="222whe2da9qkz">
        <div className="mx-auto flex h-24 w-24 flex-col items-center justify-center rounded-full border-[3px] border-amber text-amber" data-id="element-130" data-mp="1x421p9am4i53">
          <span className="font-display text-4xl font-extrabold leading-none" data-id="element-131" data-mp="19f0lv0zga4ps">7</span>
          <span className="text-[10px] font-semibold uppercase tracking-widest" data-id="element-132" data-mp="14h8x2fu3qypt">
            Days
          </span>
        </div>
        <p className="mt-6 text-[11px] font-semibold uppercase tracking-[1.8px] text-amber" data-id="element-133" data-mp="1j6dfny4t74yg">
          Zero risk
        </p>
        <h2 id="guarantee-heading" className="mt-3 font-display font-bold text-white text-3xl sm:text-5xl" data-id="element-134" data-mp="qnzrkq99yxck">
          Open everything. <span className="text-amber" data-id="element-135" data-mp="lowkz1dncj2h">Run a week from it.</span>
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-base text-white/75" data-id="element-136" data-mp="oyqdq8ixhvj5">
          Read the volumes, print a Lesson Card, set your three lanes and run a
          class straight from the page. If Figure Skating Class Ready
          doesn&apos;t change how you plan your group lessons, email us within
          7 days and you get every cent back.
        </p>
        <ul className="mt-7 flex flex-wrap justify-center gap-2.5" data-id="element-137" data-mp="60nlzlyzxkhn">
          {chips.map(chip => <li key={chip} className="rounded-full border border-rink-line px-4 py-2 text-[13px] text-white/75" data-id="element-138" data-mp="azgvz4f2qtd2">
              {chip}
            </li>)}
        </ul>
      </div>
    </section>;
}